import React from "react";
import { ProgressBar, Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./StaticProgressBar.scss";
import ComparerIndicator from "../ComparerIndicator/ComparerIndicator";
import Const from "const.json";
import NavigationButton from "../NavigationButton/NavigationButton";
import { ActiveComponentEnum } from "enums/enums";
import { SlArrowLeft } from "react-icons/sl";
import { ListWithLogoProps } from "types/ListAndDetailTypes";
import Logo from "components/ui/Logo";
import { numberWithCommas } from "utils/utils";

const StaticProgressBar: React.FC<ListWithLogoProps> = ({ complaints, progressBarAriaLabel, onNavigate, showIcon = true }) => {
  const resolved = Math.max(...complaints.map((d) => d.complaintsCount));

  return (
    <Container role="region" aria-label={progressBarAriaLabel}>
      <Col className="text-center mt-4">
        {complaints.map((item, index) => (
          <Row key={index} className="progress-row">
            <div className="item-content">
              {
                showIcon &&
                <div className="logo-container">
                  <Logo className="logo-size" src={item.id} alt={`${Const.logoOf + " " + item.description}`} defaultLogo={item.type} />
                </div>
              }
              <div className="w-100">
                <div className="d-flex justify-content-between">
                  <h5>{item.description}</h5>
                  <div className="d-flex align-items-center">
                    <span className="bold black ps-2">
                      {numberWithCommas(item.complaintsCount)} {Const.complaints}
                    </span>
                    <div >
                      <ComparerIndicator comparerData={item.comparerData} ariaLabelText={`${Const.in} ${item?.comparerData.isIncrease ? Const.upwardTrend : Const.downwardTrend} ${Const.correspondingThePreviousYear}`} isWithDifferenceOf={true}/>
                    </div>
                  </div>
                </div>
                <ProgressBar className="mb-1 mt-1" now={(item.complaintsCount / resolved) * 100} />
                {
                  onNavigate &&
                  <NavigationButton
                    navigateTo={ActiveComponentEnum.EntityDetails}
                    text={Const.forExpansion}
                    icon={<SlArrowLeft />}
                    iconLabel={Const.leftIcon}
                    additionalParams={item}
                    onNavigate={onNavigate}
                    ariaLabelText={item.description}
                  />
                }
              </div>
            </div>
          </Row>
        ))}
      </Col>
    </Container>
  );
};

export default StaticProgressBar;
